import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type loginHeaderContentDetailsInitialStateType = {
  loginHeaderContent: any;
  loading: boolean;
  error: any;
};
const initialState: loginHeaderContentDetailsInitialStateType = {
  loginHeaderContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = 'am-login-header.json'

export const getNewLoginHeaderContent = createAsyncThunk(
  "get/loginHeader-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const loginHeaderContentDetailSlice = createSlice({
  name: "loginHeader-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNewLoginHeaderContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNewLoginHeaderContent.fulfilled, (state, action) => {
      state.loginHeaderContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getNewLoginHeaderContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "login header AEM Content",
        action.error?.message,
        action?.type
      );
      state.loginHeaderContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default loginHeaderContentDetailSlice.reducer;
